import moment from "moment";

const divide = 30 * 12;

export default function calTotalALFromOriginal({ startedDate, originalDays }) {
  if (startedDate && originalDays) {
    const endOfYear = new moment()
      .set({ hour: 23, minute: 59, second: 59 })
      .endOf("year");
    const startOfYear = new moment()
      .set({ hour: 0, minute: 0, second: 0 })
      .startOf("year");
    if (moment(startedDate).isBetween(startOfYear, endOfYear)) {
      return (
        Math.round(
          (moment(endOfYear).diff(startedDate, "days") / divide) *
            originalDays *
            10
        ) / 10
      );
    } else {
      return originalDays;
    }
  }
  return 0;
}
